import {
  Injectable,
  ApplicationRef,
  createComponent,
  EnvironmentInjector,
  ComponentRef,
} from '@angular/core';
import { MaintenanceModalComponent } from '../../components/maintenance-modal/maintenance-modal.component';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceModalService {
  private modalRef: ComponentRef<MaintenanceModalComponent> | null = null;

  constructor(
    private appRef: ApplicationRef,
    private environmentInjector: EnvironmentInjector
  ) {}

  showMaintenanceModal() {
    if (this.modalRef) {
      return;
    }

    const componentRef = createComponent(MaintenanceModalComponent, {
      environmentInjector: this.environmentInjector,
    });

    this.appRef.attachView(componentRef.hostView);
    document.body.appendChild(componentRef.location.nativeElement);

    this.modalRef = componentRef;

    // Suscribirse al evento de cierre
    componentRef.instance.onClose.subscribe(() => {
      this.closeModal();
    });
  }

  private closeModal() {
    if (this.modalRef) {
      this.appRef.detachView(this.modalRef.hostView);
      this.modalRef.destroy();
      this.modalRef = null;
    }
  }
}
